export { default } from './PasswordReset.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/PasswordReset/index.js